import improperAccessCheckingService from "../services/improperAccessCheckingService";
import Constants from "../constants";

export default [
  {
    path: "/app/:userDeptRoleId/dashboard",
    name: "dashboard",
    components: {
      default: () => import("../views/dashboard/index.vue")
    }
  },
  {
    path: "/app/:userDeptRoleId/vanBanDenDetail/:id",
    name: "vanBanDenDetail",
    components: {
      default: () => import("../views/dashboard/index.vue"),
      detail: () => import("../views/doc-in/Detail.vue")
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DEN)
    }
  },
  {
    path: "/app/:userDeptRoleId/vanBanDiDetail/:id",
    name: "vanBanDiDetail",
    components: {
      default: () => import("../views/dashboard/index.vue"),
      detail: () => import("../views/doc-out/Detail.vue")
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI)
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/dashboard.js